<template>
  <div class='LinkNaveMobi'>
    <div class="cont" v-if="show">
      <div class="icon">
        <component :is="data.icon" :tam="'23px'" :color="isPainel ? Prefes.navepainel.corFont : '#000000'" @click="push(data.path)"/>
      </div>
      <div class="label" @click="push(data.path)">
        {{ 
          data.name || data.text
        }}
      </div>
      <div class="btn" v-if="subs.length">
        <arrow-icon @showSubLinks="newValue => sublink = newValue"/>
      </div>
    </div>
    <div class="cont-sub" :class="{ contsub: sublink }" ref="contshow">
      <sublink-nave-mobi
      @goPage="newValue => $emit('goPage', newValue)"
      v-for="(c, key) in subs"
      :key="key"
      :data="c"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ArrowIcon from '../Icons/ArrowIcon'
import SublinkNaveMobi from './SublinkNaveMobi'
import StoreIcon01 from '@/components/Theme01/Icons/StoreIcon01'
import CartShopIcon01 from '@/components/Theme01/Icons/CartShopIcon01'
import LikeIcon01 from '@/components/Theme01/Icons/LikeIcon01'
import ListIcon01 from '@/components/Theme01/Icons/ListIcon01'
import UserIcon01 from '@/components/Theme01/Icons/UserIcon01'
import ProdIcon from '@/components/EnbPainel/Icons/ProdIcon'
import ClientIcon from '@/components/EnbPainel/Icons/ClientIcon'
import GiftIcon from '@/components/EnbPainel/Icons/GiftIcon'
import UserIcon from '@/components/EnbPainel/Icons/UserIcon'
import ConfigIcon from '@/components/EnbPainel/Icons/ConfigIcon'
import PayIcon from '@/components/EnbPainel/Icons/PayIcon'
import DeliveryIcon from '@/components/EnbPainel/Icons/DeliveryIcon'
import MarketingIcon from '@/components/EnbPainel/Icons/MarketingIcon'
import SiteIcon from '@/components/EnbPainel/Icons/SiteIcon'
import DashIcon from '@/components/EnbPainel/Icons/DashIcon'
import LogoutIcon from '@/components/EnbPainel/Icons/LogoutIcon'
import { icons } from '@/components/icons'
export default {
  name: 'LinkNaveMobi',
  components: { 
    ArrowIcon,
    SublinkNaveMobi,
    StoreIcon01,
    CartShopIcon01,
    LikeIcon01,
    ListIcon01,
    UserIcon01,
    ProdIcon,
    ClientIcon,
    GiftIcon,
    UserIcon,
    ConfigIcon,
    PayIcon,
    DeliveryIcon,
    MarketingIcon,
    SiteIcon,
    DashIcon,
    LogoutIcon,
    ...icons
  },
  props: {
    data: {
      type: Object,
      default: () => ({ text: 'label', path: '/', icon: 'StoreIcon01' })
    },
    subs: {
      type: Array,
      default: () => ([])
    },
    login: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      sublink: false
    }
  },
  computed: {
    ...mapGetters(['Profile', 'Empresa', 'Prefes']),
    logged () {
      return  Object.keys(this.Profile).length
    },
    isPainel () {
      return this.$route.path.indexOf('painel') !== -1
    }
  },
  methods: {
    ...mapActions(['SetModal01', 'GetLogout', 'Loading', 'changeFilterProdStore', 'GetStoreProducts']),
    push (path) {
      if(typeof path === 'undefined') {
        this.pushModelo03()
        return
      }
      if(this.login && this.logged) {
        this.$emit('goPage', true)
        this.GetLogout()
          .then(() => this.$router.push(path))
        return
      }
      if(this.login) {
        this.$emit('goPage', true)
        if(this.Empresa.modelo === 'Modelo 02') {
          this.SetModal01({ component: 'EnbLogin02', active: true })
          return  
        }
        if(this.Empresa.modelo === 'Modelo 03') {
          this.SetModal01({ component: 'EnbLogin', active: true })
          return  
        }
        this.SetModal01({ component: 'EnbLogin01', active: true })
        return
      }
      this.$emit('goPage', true)
      if(this.Empresa.modelo === 'Modelo 03' && path === '/loja') {
        this.$router.push('/site')
        return
      }
      this.$router.push(path)
    },
    async pushModelo03 () {
      this.$router.push(`/site/${this.data.link}`)
      this.Loading(true)
      this.changeFilterProdStore({ categoria: this.data.link })
        .then(() => {
          this.$emit('goPage', true)
          this.GetStoreProducts({ params: { last: [], limit: 8, categoria: this.data.link }, init: true })
          this.Loading(false)
        })
    }
  },
  mounted () {
    this.$refs.contshow.addEventListener("animationend",function (e) {
      e.stopPropagation()
    })
  }
}
</script>

<style scoped>
.LinkNaveMobi {
}

.cont {
  display: flex;
  width: 100%;
  border-bottom: thin solid #EEEEEE;
}

.icon {
  width: 9%;
  display: flex;
  justify-content: end;
  padding-right: 1%;
  padding-top: 3%;
  padding-bottom: 3%;
} 

.label {
  width: 75%;
  display: flex;
  align-items: center;
}

.cont-sub {
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
}

.contsub {
  max-height: 500px;
  transition: max-height 0.4s ease-in;
}

.btn {
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: thin solid #EEEEEE;
}

</style>
